'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EducationModel = require('../model/EducationModel');

var _EducationModel2 = _interopRequireDefault(_EducationModel);

var _TextControl = require('../../../lib/ui/TextControl');

var _TextControl2 = _interopRequireDefault(_TextControl);

var _PickerControl = require('../../../lib/ui/PickerControl');

var _PickerControl2 = _interopRequireDefault(_PickerControl);

var _SelectPerson = require('../../person/action/SelectPerson');

var _SelectPerson2 = _interopRequireDefault(_SelectPerson);

var _SelectLocation = require('../../location/action/SelectLocation');

var _SelectLocation2 = _interopRequireDefault(_SelectLocation);

var _DateControl = require('../../../lib/ui/DateControl');

var _DateControl2 = _interopRequireDefault(_DateControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EducationForm = function () {
  function EducationForm(element, args) {
    var _this = this;

    _classCallCheck(this, EducationForm);

    var fieldsetEducation = document.createElement('fieldset');
    var legendEducation = document.createElement('legend');
    legendEducation.innerHTML = 'Opleiding';
    fieldsetEducation.appendChild(legendEducation);
    var popup = null;

    this.id = args.education.values.id;
    this.person = new _PickerControl2.default(fieldsetEducation, { label: 'Persoon', value: args.education.values.person_id,
      onchange: args.onchange,
      onselect: function onselect(item) {
        if (item.values.id) {
          window.PRIM.navigate('/people/' + item.values.id);
        }
      },
      onclick: function onclick() {
        var popupElement = document.getElementById('popup');
        var viewportElement = document.getElementById('viewport');

        popup = new _SelectPerson2.default(popupElement, {
          onok: function onok(item) {
            if (item && item.values.id) {
              _this.person.setValue(item.values.id, item);
            } else {
              _this.person.setValue(null, null);
            }

            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
            _this.person.onchange();
          },
          oncancel: function oncancel() {
            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
          }
        });
        viewportElement.classList.add('invisible');
        popupElement.classList.remove('invisible');
      }
    });
    this.location = new _PickerControl2.default(fieldsetEducation, { label: 'Locatie', value: args.education.values.location_id,
      onchange: args.onchange,
      onselect: function onselect(item) {
        if (item.values.id) {
          window.PRIM.navigate('/locations/' + item.values.id);
        }
      },
      onclick: function onclick() {
        var popupElement = document.getElementById('popup');
        var viewportElement = document.getElementById('viewport');

        popup = new _SelectLocation2.default(popupElement, {
          onok: function onok(item) {
            if (item && item.values.id) {
              _this.location.setValue(item.values.id, item);
            } else {
              _this.location.setValue(null, null);
            }

            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
            _this.location.onchange();
          },
          oncancel: function oncancel() {
            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
          }
        });
        viewportElement.classList.add('invisible');
        popupElement.classList.remove('invisible');
      }
    });
    this.title = new _TextControl2.default(fieldsetEducation, { label: 'Titel', value: args.education.values.title, readonly: window.PRIM.hasReadonlyModuleAccess('educations'), onchange: args.onchange });
    this.start = new _DateControl2.default(fieldsetEducation, { label: 'Start', value: args.education.values.start, readonly: window.PRIM.hasReadonlyModuleAccess('educations'), onchange: args.onchange });
    this.end = new _DateControl2.default(fieldsetEducation, { label: 'Einde', value: args.education.values.end, readonly: window.PRIM.hasReadonlyModuleAccess('educations'), onchange: args.onchange });

    var fragment = document.createDocumentFragment();
    fragment.appendChild(fieldsetEducation);

    element.appendChild(fragment);
  }

  _createClass(EducationForm, [{
    key: 'getValue',
    value: function getValue() {
      var education = new _EducationModel2.default();
      education.person = this.person.getItem();
      education.location = this.location.getItem();
      education.values.id = this.id;
      education.values.location_id = this.education.getValue();
      education.values.title = this.title.getValue();
      education.values.start = this.start.getValue();
      education.values.end = this.end.getValue();
      return education;
    }
  }, {
    key: 'setValue',
    value: function setValue(education) {
      this.id = education.values.id;
      this.person.setValue(education.values.person_id, education.person);
      this.location.setValue(education.values.location_id, education.location);
      this.title.setValue(education.values.title);
      this.start.setValue(education.values.start);
      this.end.setValue(education.values.end);
    }
  }]);

  return EducationForm;
}();

exports.default = EducationForm;


//////////////////
// WEBPACK FOOTER
// ./js/modules/education/ui/EducationForm.js
// module id = 59
// module chunks = 0